import { useState } from 'react';

const THEME_KEY = 'a2g_transfer_theme';

// Light is the default; the choice is remembered but must never break the page
// when storage is unavailable. One preference shared by the landing and the
// Transfer Site pages, so it follows the visitor from page to page.
const readTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) === 'dark';
  } catch {
    return false;
  }
};

export const useTransferTheme = () => {
  const [dark, setDark] = useState(readTheme);
  const toggle = () => setDark((d) => {
    try { localStorage.setItem(THEME_KEY, d ? 'light' : 'dark'); } catch { /* storage unavailable */ }
    return !d;
  });
  return [dark, toggle];
};
